import React, { useState, useEffect } from "react";
import SubProfile from "../components/Profile/SubProfile";
import CustomizedTables from "../components/Profile/PurchaseProfile";
import "../components/Profile/profile.css";

const Profile = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [runDarkMode, setRunDarkMode] = useState(0)
  const getLocalStorageDarkMode =
    localStorage.getItem("DarkMode") || [];

  useEffect(() => {
    setIsDarkMode(getLocalStorageDarkMode);
  }, [runDarkMode]);
  // console.log(isDarkMode, typeof isDarkMode);

  return (
    <section
      className={`px-4 pt-36 mb-[-50px] mt-[-90px] z-[1] min-h-[100vh] profile-main relative   ${
        isDarkMode === "Dark" ? "darkMode":"normal"
      }`}
    >
      <SubProfile setRunDarkMode={setRunDarkMode} isDarkMode={isDarkMode}/>
      <CustomizedTables />
    </section>
  );
};

export default Profile;
